"use client";
import Image from "next/image";
import React from "react";
import FlatGlassBanner from "../../../public/assets/background/beer_banner.jpg";
import { IoCaretForward } from "react-icons/io5";
import CtbBanner from "../../../public/assets/background/why-beer_bg.jpg";
import GlassImg from "../../../public/assets/background/bg_factory.jpg";
import Link from "next/link";

import { HiHome } from "react-icons/hi2";
import { BsPatchCheckFill } from "react-icons/bs";
import MoreToExplore from "@/components/product/ExploreMore";
import MoreToExploreMobile from "@/components/product/ExploreMoreMobile";
import BeerClients from "@/components/product/beerClients/BeerClients";
import BeerClientsMobile from "@/components/product/beerClients/BeerClientsMobile";

const FlatGlass = () => {
  return (
    <>
      {/* Banner Section */}
      <section className="relative ">
        <div className="grid grid-cols-1 xl:mt-17">
          <Image
            src={FlatGlassBanner}
            alt="flat-glass"
            className="w-full h-full"
            priority={true}
          />
        </div>
        <div className="breadcrumb">
          <ul className="flex items-center justify-center gap-2 p-2">
            <li>
              <Link
                href=""
                className="flex items-center font-medium text-sm gap-1 text-red-600"
              >
                <HiHome />
                Home
              </Link>
            </li>
            <li className="text-sm text-gray-600">/</li>
            <li>
              <Link
                href=""
                className="flex items-center font-medium text-sm text-gray-400"
              >
                Beer Bottle
              </Link>
            </li>
          </ul>
        </div>
      </section>

      <section className="py-[50px] px-6 xl:mb-5 mb-0">
        <div className="container mx-auto">
          <div className="grid  xl:grid-cols-2  grid-cols-1 gap-5 items-center transition ease-in-out duration-500">
            {/* Left Column */}
            <div>
              <h2 className="title !text-[#033b6f] !mb-0">
                Premium Amber & <span className="text-[#d42427]"> Green </span>
                Glass
              </h2>
              <h5 className="text-xl  font-semibold">
                Bottles by Emerge Glass
              </h5>

              <div className="pt-5">
                <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-3 text-justify">

                  
                  At <strong>Emerge Glass</strong>, we take pride in being one of India’s most
                  trusted manufacturers of <strong>Amber and Green glass bottles</strong>. With
                  over <strong>12 years of manufacturing excellence</strong>, state-of-the-art
                  facility, equipped with manufacturing and inspection machines
                  bought from Emhart; (leading manufacturer of glass bottle
                  manufacturing machines), equipments ensuring precision in
                  process and quality control with laboratory equipped with high
                  precision equipment assuring <strong>strength, safety, and superior
                  presentation</strong> for global and Indian brands in Beer, liquor and
                  pharmaceutical industry.
                </p>
                <p className="text-sm text-gray-600 text-justify mb-3">
                 Emerge Glass facility is capable of producing bottles in NNPB process, ensuring light weight bottles with high strength to provide commercial and technical advantages to our customers. The highly qualified and experienced officials run the business professionally with high dedication.  
                </p>
              </div>
            </div>

            <div className="">
              <video
                src="https://www.emergeglass.in/beer_bottle.mp4"
                className="rounded-lg"
                autoPlay
                muted
                loop
                playsInline
              ></video>
            </div>
          </div>
        </div>
      </section>
      <section className="xl:py-[80px] !pt-[20px] pb-[50px] px-6">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 items-center gap-6">
            {/* Content Section (comes first on mobile/tablet) */}
            <div className="order-1 lg:order-2 bg-gradient-to-b from-red-50 to-blue-50 p-6 md:p-8 shadow-2xl h-auto lg:h-[97%]  lg:col-span-2 relative z-40 lg:-ml-[20%] rounded-lg border-b-4 border-red-400">
              <h2 className="title !text-[#033b6f] !text-center !text-2xl">
                Our  <span className="text-[#d42427]"> Colour  </span>
                Glass Bottle Range
              </h2>

              <p className="mb-3 font-semibold text-[#003049] text-sm">
              We are capable to produce following range of bottles in Amber, Green and Flint colours:-
              </p>

              <ul className="flex flex-col gap-4 text-sm md:text-base text-gray-700 leading-relaxed">
                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Beer Bottles  –
                    </span> <span className="text-[#003049] font-semibold text-sm">
                      Produced in 330 ml and 650 ml sizes with NNPB and B&B process. Each Bottle passes through on-line inspection machines and standard operating practices are complied with to test these in lab through simulation for strength and dimensional precision.
                    </span>
                  </p>
                </li>

                <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Liquor and Pharma Glass Bottles  –
                    </span> <span className="text-[#003049] font-semibold text-sm">
                     Manufactured in B&B process in range 30 ml to 1000 ml, duly tested for precision and strength.
                    </span>
                  </p>
                </li>

                 <li className="flex items-start gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Glass Vials  –
                    </span> <span className="text-[#003049] font-semibold text-sm">
                     Manufactured with high precision in range 10 ml to 100 ml.
                    </span>
                  </p>
                </li>
              </ul>

          
            </div>

            {/* Image Section (comes second on mobile/tablet) */}
            <Image
              src={GlassImg}
              alt="factory image"
              loading="lazy"
              className="order-2 lg:order-1 rounded-lg relative z-10 w-full h-auto lg:col-span-3"
            />
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden ">
        <Image
          src={CtbBanner}
          alt="call to action banner"
          className="w-full h-[600px] object-cover"
          loading="lazy"
        />

        <div className="absolute inset-0 bg-black/60 z-10"></div>

        <div className="absolute inset-0 md:w-full w-[92%] md:left-0 left-1/2 md:translate-x-0 -translate-x-1/2 flex items-start justify-center z-20 flex-col container mx-auto px-6">
          <h2 className="xl:text-4xl text-2xl font-bold text-left text-[#fff] mb-5">
            Why Emerge Glass Beer <span className="text-red-400">Bottles?</span>
          </h2>

          <ul className="mt-5 flex flex-col gap-4 text-gray-300">
            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Trusted by Leading Indian Beer Brands
                </span>
                <br />
                Supplying to some of the most popular names in the industry.
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Advanced Manufacturing Technology
                </span>
                <br />
                State-of-the-art furnaces for consistent quality and flawless
                finish.
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">Strength & Safety</span>
                <br />
                Designed to withstand high pressure and maintain integrity
                during transportation and storage.
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Preserves Freshness
                </span>
                <br />
                Glass ensures zero interaction with contents, keeping the beer
                pure and flavorful.
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Sustainable & Eco-friendly
                </span>
                <br />
                100% recyclable glass bottles that support environmental
                responsibility.
              </p>
            </li>
          </ul>

          {/* {[
              "Trusted by Leading Indian Beer Brands – Supplying to some of the most popular names in the industry.",
              " Advanced Manufacturing Technology – State-of-the-art furnaces for consistent quality and flawless finish.",
              "Strength & Safety – Designed to withstand high pressure and maintain integrity during transportation and storage.",
              " Preserves Freshness – Glass ensures zero interaction with contents, keeping the beer pure and flavorful.",
              " Sustainable & Eco-friendly – 100% recyclable glass bottles that support environmental responsibility.",
            ].map((item, idx) => (
              <li key={idx} className="flex items-center gap-2">
                <p className="bg-red-100 grid place-items-center w-4 h-4 rounded text-red-400 text-xs">
                  <IoCaretForward />
                </p>
                <p className="text-sm text-gray-300 font-medium flex flex-1">
                  {item}
                </p>
              </li>
            ))}
          </ul> */}
        </div>
      </section>

      <section className=" relative bg-gradient-to-b from-white to-[#fbf9f5]">
        <BeerClients />
        <BeerClientsMobile />
      </section>

      <section className=" py-[50px] xl:pb-[100px] px-4 md:px-0 relative bg-gradient-to-b from-gray-800 to-[#fbf9f5]">
        <h2 className="title !text-[#fff] !mb-5 !text-center">
          Explore <span className="text-[#d42427]"> More </span>
          Products
        </h2>

        <MoreToExplore />
        <MoreToExploreMobile />
      </section>
    </>
  );
};

export default FlatGlass;
